import { useState, useEffect } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import Api from '../api/api';
import stringHelpers from '../../utilities/stringHelpers';
import Loader from '../shared/loader';
import { ErrorModal } from '../../utilities/errorModal';
import { DebtCollectionProviderDisplay } from './debtCollectionProviderDisplay';
import Enum from '../../utilities/enum';
import formUtilities from '../../utilities/formUtilities';

export const DebtCollectionProvider = ({ organisationId, token }) => {
    const { providerId } = useParams()
    const history = useHistory()
    const location = useLocation()
    const returnUrl = `/organisation/${ organisationId }/debt-collection-providers`
    const isNew = stringHelpers.isNullOrEmpty(providerId)
    const [isInEdit, setIsInEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [debtCollectionProvider, setDebtCollectionProvider] = useState(null)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [name, setName] = useState("")
    const [debtCollectionType, setDebtCollectionType] = useState("0")
    const [debtViewTenant, setDebtViewTenant] = useState("")
    const [debtViewApiKey, setDebtViewApiKey] = useState("")
    const [showStringGenerationModal, setShowStringGenerationModal] = useState(false)
    const [debtViewSubscriptionKey, setDebtViewSubscriptionKey] = useState("")
    const [debtViewClientKey, setDebtViewClientKey] = useState("")
    const [debtViewPassword, setDebtViewPassword] = useState("")
    const [debtViewUsername, setDebtViewUsername] = useState("")
    const [dcblUsername, setDcblUsername] = useState("")
    const [dcblPassword, setDcblPassword] = useState("")
    const [dcblClientPointer, setDcblClientPointer] = useState("")
    const [dcblPlacement, setDcblPlacement] = useState(null)
    const debtViewWebhookBaseUrl = `https://api.advancedparking.tech/${ organisationId }/webhooks/debtview`
    const [errorMessage, setErrorMessage] = useState(null)

    const getDebtCollectionProvider = () => {
        Api.getDebtCollectionProvider(
            data => {
                setDebtCollectionProvider(data)
                setName(data.name)
                setDebtCollectionType(String(data.debtCollectionType))
                setDebtViewApiKey(data.debtViewApiKey)
                setDebtViewSubscriptionKey(data.debtViewSubscriptionKey)
                setDebtViewClientKey(data.debtViewClientKey)
                setDebtViewPassword(data.debtViewPassword)
                setDebtViewUsername(data.debtViewUsername)
                setDebtViewTenant(data.debtViewTenant)
                setDcblUsername(data.dcblUsername)
                setDcblPassword(data.dcblPassword)
                setDcblClientPointer(data.dcblClientPointer)
                setDcblPlacement(data.dcblPlacement)
                setIsLoading(false)
            },
            error => {
                console.log(error)
                setIsLoading(false)
            },
            providerId,
            organisationId, token
        )
    }

    const submit = () => {
        setIsLoading(true)
        if (!isNew) {
            Api.editDebtCollectionProvider(
                data => {
                    if (data.isError) {
                        setErrorMessage(data.errorMessage)
                    } else {
                        setIsInEdit(false)
                        getDebtCollectionProvider()
                    }
                    setIsLoading(false)
                },
                error => {
                    console.log(error)
                    setErrorMessage(error.errorMessage)
                    setIsLoading(false)
                },
                providerId,
                name,
                Number(debtCollectionType),
                debtCollectionProvider.isDefault,
                debtViewTenant,
                debtViewUsername,
                debtViewPassword,
                debtViewSubscriptionKey,
                debtViewClientKey,
                debtViewApiKey,
                !stringHelpers.isNullOrEmpty(dcblUsername) ? dcblUsername : null,
                !stringHelpers.isNullOrEmpty(dcblPassword) ? dcblPassword : null,
                !stringHelpers.isNullOrEmpty(dcblClientPointer) ? dcblClientPointer : null,
                !stringHelpers.isNullOrEmpty(String(dcblPlacement ?? "")) ? Number(dcblPlacement) : null,
                organisationId,
                token
            )
        } else {
            Api.addDebtCollectionProvider(
                data => {
                    if (data.isError) {
                        setErrorMessage(data.errorMessage)
                    } else {
                        setIsInEdit(false)
                        history.push(`/organisation/${ organisationId }/debt-collection-provider/${data.id}`)
                    }
                    setIsLoading(false)
                },
                error => {
                    console.log(error)
                    setErrorMessage(error.errorMessage)
                    setIsLoading(false)
                },
                name,
                Number(debtCollectionType),
                false,
                debtViewTenant,
                debtViewUsername,
                debtViewPassword,
                debtViewSubscriptionKey,
                debtViewClientKey,
                debtViewApiKey,
                !stringHelpers.isNullOrEmpty(dcblUsername) ? dcblUsername : null,
                !stringHelpers.isNullOrEmpty(dcblPassword) ? dcblPassword : null,
                !stringHelpers.isNullOrEmpty(dcblClientPointer) ? dcblClientPointer : null,
                !stringHelpers.isNullOrEmpty(String(dcblPlacement ?? "")) ? Number(dcblPlacement) : null,
                organisationId,
                token
            )
        }
    }

    const handleDelete = () => {
        Api.deleteDebtCollectionProvider(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    history.push(returnUrl)
                }
            },
            error => {
                console.log(error)
                setErrorMessage(error.message)
            },
            providerId,
            organisationId, token
        )
    }

    const handleCancel = () => {
        if (isNew) {
            history.push(returnUrl)
        } else {
            setIsInEdit(false)
        }
    }

    useEffect(() => {
        if (isNew) {
            setIsInEdit(true)
        } else {
            setIsInEdit(false)
            setIsLoading(true)
            getDebtCollectionProvider()
        }
        if (location && location.state !== undefined && location.state.editMode !== undefined) {
            setIsInEdit(location.state.editMode)
        }
    }, [location])

    const detailsHeading = isNew ? "Add new debt collection provider" : "Debt collection provider -"

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        {
                            <div className="card-header">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h5 className="mb-0 d-flex align-items-center">
                                            { detailsHeading } <p className="ml-2 mb-0">{ debtCollectionProvider?.name }</p></h5>
                                    </div>
                                    <button className="btn btn-falcon-default btn-sm mr-3 py-1" type="button" onClick={ () => history.push(returnUrl) }>
                                        <i className="fas fa-reply mr-1"></i>Back
                                    </button>
                                    { !isNew &&
                                        <>
                                            <button type="button" className="btn btn-primary btn-sm mr-3" onClick={ () => setIsInEdit(!isInEdit) }>
                                                <i className="fas fa-edit"></i> Edit
                                            </button>
                                            <button className="btn btn-falcon-default btn-sm dropdown-toggle py-2 mr-3 dropdown-caret-none" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i className="fas fa-ellipsis-h"></i></button>
                                            <div className="dropdown-menu dropdown-menu-right" x-placement="bottom-start">
                                                <button onClick={ () => setShowDeleteModal(true) } className="dropdown-item text-danger">
                                                    <i className="fas fa-times mr-1"></i>Delete provider</button>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div> }
                        {
                            isLoading
                                ? <Loader />
                                : isInEdit
                                    ? <>
                                        <div className="card-body bg-light border-top details-container">
                                            <div className="row mb-1">
                                                <div className="col-md-3">
                                                    <p className="font-weight-semi-bold m-0 mt-1">Name</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group mb-1">
                                                        <input required className="form-control mb-0" type="text" value={ name } 
                                                        onChange={ e => {
                                                            setName(e.target.value)
                                                            formUtilities.requiredField(e.target.parentNode, e.target.value)
                                                        } } />
                                                        <small className='invalid-feedback text-danger'>Please enter a name</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-12">
                                                    <p className="font-weight-semi-bold mb-3">Default</p>
                                                </div>
                                                <div className="col-md-6 col-12 pt-1">
                                                    {
                                                        !isNew
                                                        ? <>
                                                            { debtCollectionProvider.isDefault && <i className="fas fa-check text-success"></i> }
                                                            { !debtCollectionProvider.isDefault && <i className="fas fa-times text-danger"></i> }
                                                        </>
                                                        : <i className="fas fa-times text-danger"></i>
                                                    }
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-md-3">
                                                    <p className="font-weight-semi-bold m-0 mt-1">Method</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <select value={ debtCollectionType } onChange={ e => setDebtCollectionType(e.target.value) } className="form-control">
                                                        {
                                                            Object.entries(Enum.DebtCollectionType).map(
                                                                ([key, value]) => <option key={ key } value={ key }>{ value }</option>
                                                            )
                                                        }
                                                    </select>
                                                </div>
                                            </div>

                                            {
                                                debtCollectionType === "2" &&
                                                <>
                                                    <div className="row mb-1">
                                                        <div className="col-md-3">
                                                            <p className="font-weight-semi-bold m-0 mt-1">Tenant</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="text" value={ debtViewTenant } onChange={ e => setDebtViewTenant(e.target.value) } />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-1">
                                                        <div className="col-md-3">
                                                            <p className="font-weight-semi-bold m-0 mt-1">Subscription Key</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="text" value={ debtViewSubscriptionKey } onChange={ e => setDebtViewSubscriptionKey(e.target.value) } />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-1">
                                                        <div className="col-md-3">
                                                            <p className="font-weight-semi-bold m-0 mt-1">Client Key</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="text" value={ debtViewClientKey } onChange={ e => setDebtViewClientKey(e.target.value) } />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-1">
                                                        <div className="col-md-3">
                                                            <p className="font-weight-semi-bold m-0 mt-1">Username</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="text" value={ debtViewUsername } onChange={ e => setDebtViewUsername(e.target.value) } />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-1">
                                                        <div className="col-md-3">
                                                            <p className="font-weight-semi-bold m-0 mt-1">Password</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="text" value={ debtViewPassword } onChange={ e => setDebtViewPassword(e.target.value) } />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <p className="font-weight-semi-bold mt-1">Webhook base URL</p>
                                                        </div>
                                                        <div className="col-md-6 d-flex align-items-start">
                                                            <div className="mb-0 input-group">
                                                                <input className="border rounded-left mb-1 form-control-plaintext px-3 bg-white" type="text" value={ debtViewWebhookBaseUrl } readOnly />
                                                                <div className="input-group-append">
                                                                    <button onClick={ () => navigator.clipboard.writeText(debtViewWebhookBaseUrl) } className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center"><i className='fas fa-copy'></i></button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-1">
                                                        <div className="col-md-3">
                                                            <p className="font-weight-semi-bold m-0 mt-1">Webhook API Key</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="input-group mb-1">
                                                                <input onChange={ (e) => setDebtViewApiKey(e.target.value) } className="border rounded-left form-control mb-1 form-control-plaintext px-3 bg-white" type="text" value={ debtViewApiKey } />
                                                                <div className="input-group-append">
                                                                    <button type='button' onClick={ () => setShowStringGenerationModal(true) } className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center"><i className='fas fa-undo'></i></button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }

                                            {
                                                debtCollectionType === "3" &&
                                                <>
                                                    <div className="row mb-1">
                                                        <div className="col-md-3">
                                                            <p className="font-weight-semi-bold m-0 mt-1">Username</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="text" value={ dcblUsername ?? "" } onChange={ e => setDcblUsername(e.target.value) } />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-1">
                                                        <div className="col-md-3">
                                                            <p className="font-weight-semi-bold m-0 mt-1">Password</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="text" value={ dcblPassword ?? "" } onChange={ e => setDcblPassword(e.target.value) } />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-1">
                                                        <div className="col-md-3">
                                                            <p className="font-weight-semi-bold m-0 mt-1">Client Pointer</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="text" value={ dcblClientPointer ?? "" } onChange={ e => setDcblClientPointer(e.target.value) } />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-1">
                                                        <div className="col-md-3">
                                                            <p className="font-weight-semi-bold m-0 mt-1">Placement</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="number" value={ dcblPlacement ?? "" } onChange={ e => setDcblPlacement(e.target.value) } />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                        <div className="card-footer border-top">
                                            <div className="row client-edit-buttons">
                                                <div className="col-12 col-sm-auto ml-auto pl-0">
                                                    <div id="dashboard-actions">
                                                        <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ handleCancel }>
                                                            <i className="fas fa-times mr-1"></i>
                                                            Cancel
                                                        </button>
                                                        <button
                                                            disabled={debtCollectionType === "0" || stringHelpers.isNullOrEmpty(name)}
                                                            type="button" className="btn btn-success btn-sm ml-2" onClick={ () => submit() }>
                                                            <i className="fas fa-check mr-1"></i>
                                                            Confirm
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    : debtCollectionProvider && <DebtCollectionProviderDisplay debtCollectionProvider={ debtCollectionProvider } organisationId={ organisationId } />
                        }
                    </div>
                </div>
            </div>
            { !stringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal message={ errorMessage } onHide={ () => setErrorMessage(null) } /> }
            {
                showDeleteModal &&
                <Modal show onHide={ () => setShowDeleteModal(false) } centered>
                    <Modal.Header>
                        <Modal.Title className="d-flex gap-2 align-items-center text-danger">Delete debt collection provider</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="font-weight-semi-bold mt-1 mb-2">Are you sure you want to delete <b>{ name }</b>?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => setShowDeleteModal(false) }>Cancel</button>
                        <button type="button" className="btn btn-danger btn-sm ml-2" onClick={ () => {
                            setShowDeleteModal(false)
                            handleDelete()
                        } }>Delete</button>
                    </Modal.Footer>
                </Modal>
            }

            {
                showStringGenerationModal &&
                <Modal show onHide={ () => setShowStringGenerationModal(false) } centered>
                    <Modal.Header>
                        <Modal.Title className="d-flex gap-2 align-items-center">DebtView API Key</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="font-weight-semi-bold mt-1 mb-2">This will generate a new Webhook API Key. Are you sure?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size="sm" variant='secondary' onClick={ () => setShowStringGenerationModal(false) }>Cancel</Button>
                        <Button size="sm" variant='success' onClick={ () => {
                            setDebtViewApiKey(stringHelpers.generateRandomString())
                            setShowStringGenerationModal(false)
                        } }>Confirm</Button>
                    </Modal.Footer>
                </Modal>
            }
        </div>
    )
}
